import { interval } from 'rxjs'
import { mergeMap, map, takeUntil, filter, startWith } from 'rxjs/operators'
import { ofType, ActionsObservable, StateObservable } from 'redux-observable'
import { ReduxAction, State } from '../../../reducers/reducerType'
import usernameLib from '../../../../lib/username'
import { roomTypes } from '../../../actions/room/roomTypes'
import { setupTypes } from '../../../actions/setup/setupTypes'
import { terminateGig } from '../../../actions/gig/gigActions'
import { ActionCreatorWithoutPayload } from '@reduxjs/toolkit'
import { extendUserSession } from '../../../actions/room/room'

const extendUserSession$ = (action$: ActionsObservable<ReduxAction>, state$: StateObservable<State>) => action$.pipe(
  ofType(setupTypes.SET_ROOM),
  filter(() =>
    (
      usernameLib.isPresenter(state$.value.config.username || '') ||
      usernameLib.isObserver(state$.value.config.username || '')
    )
  ),
  mergeMap(() => {

      return interval(60 * 60 * 1000).pipe(
        takeUntil(
          action$.pipe(
            ofType<
            ReduxAction<any> | ActionCreatorWithoutPayload<string>,
            any,
            string | roomTypes.TEAR_DOWN_ROOM_SUCCESS
          >(roomTypes.TEAR_DOWN_ROOM_SUCCESS, terminateGig().type)
          )
        ),
        startWith(() => extendUserSession()),
        map(() => extendUserSession())
      )

    }

  )
)

export default extendUserSession$
